import GameBaseState from "./GameBaseState";
import Logger from "@js/logger";
import * as Accounts from "@js/account";
import { IStateType } from "./IGameState";
import { yunpb } from "@/types/protobuf";
import BusinessManager from "@/js/controls";
import ERROR from "@js/error";
import IPCCenter from "@/js/ipc";
import { EVENTCMD } from "@/js/events";
export default class GameStateInQueue extends GameBaseState {
  private playerStatusData;
  private myType = IStateType.IN_QUE;
  constructor() {
    super();
    this.playerStatusData = this.playGameStore.playerStatusData;
  }
  // 第一次状态初始化的操作
  onPageReload() {
    Logger.log(`GameState ${IStateType[this.myType]} onPageReload`);
    Accounts.setCurrentGame(this.playerStatusData.gameNode!);
    this.playGameStore.isQueueing = true;
    this.playGameStore.showFloatModal({
      playerOper: this.PLAYERSTATUS.IN_QUE,
      queIndex: this.playerStatusData.queIndex,
      waitTime: this.playerStatusData.waitTime,
      queueInfo: this.playerStatusData.queueInfo,
    });
  }
  // 状态转换的操作
  async onStateEnter() {
    const game: yunpb.IGetGameRoomInfoRsp = Accounts.getSelectGame();
    const gameId = game.gameBaseInfo?.gameId as number;
    await this.playGameStore.handleGetQueuePanel(gameId);
    await this.playGameStore.showQueueModal({
      playerOper: this.PLAYERSTATUS.IN_QUE,
    });
  }
  resetState() {
    Logger.log("GameState IN-QUEUE resetState");
    const game: yunpb.IGetGameRoomInfoRsp = Accounts.getSelectGame();
    const playingGame: pro.yunpb.IGameNode = Accounts.getCurrentGame();
    if (!playingGame) {
      this.reQueueGame();
      return;
    }
    if (Accounts.gameEqual(playingGame, game.gameBaseInfo!)) {
      Logger.log("GameState IN-QUEUE gameEqual");
      this.playGameStore.showQueueModal({
        playerOper: this.PLAYERSTATUS.IN_QUE,
      });
    } else {
      this.playGameStore.showExitModal({
        from: playingGame.name,
        to: game.gameBaseInfo?.gameName,
      });
    }
  }
  //
  playGame(game?: yunpb.IGetGameRoomInfoRsp | null) {
    Logger.log("GameState IN-QUEUE playGame");
    if (this.playGameStore.isQueueing) {
      Accounts.setSelectGame(game as yunpb.IGameNode);
      this.resetState();
    }
  }
  // 取消排队
  async exitGame() {
    Logger.log("GameState IN-QUEUE exitGame");
    const ret = await BusinessManager.CancelQue(Accounts.getAccountId());

    if (ret && ret.code === 0) {
      Accounts.setCurrentGame(null);
      // 切换状态为FREE空闲中
      // this.setState(IStateType.FREE);
      IPCCenter.getInstance().broadCastEvent(
        EVENTCMD.SetCurrentGameState,
        IStateType.FREE
      );
    } else {
      this.showToastMessage(ERROR.errorMessage(ret?.obj));
    }
  }
}
